import { sessionTimingUpdated } from './actions';

const SESSION_EXTEND_API = '/ECM/session/extend';

/**
 * Result indicators.
 */
export const ExtendResult = {
  SUCCESS: 'success',
  REDIRECT: 'redirect',
  FAILED: 'failed',
};

/**
 * Calls POST /ECM/session/extend and returns the parsed result.
 * Pure data fetch — no side effects.
 */
async function callSessionExtendApi() {
  try {
    const response = await fetch(SESSION_EXTEND_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      redirect: 'manual',
    });

    if (response.type === 'opaqueredirect' || response.redirected) {
      return { result: ExtendResult.REDIRECT };
    }

    if (!response.ok) {
      return { result: ExtendResult.FAILED };
    }

    const data = await response.json();

    return {
      result: ExtendResult.SUCCESS,
      data: {
        timeoutMins: data.timeoutMins,
        promptMins: data.promptMins || 0,
        lastRefreshedAt: data.lastRefreshedAt,
      },
    };
  } catch {
    return { result: ExtendResult.FAILED };
  }
}

/**
 * Extends the session (keep-alive) and updates Redux with the new timing.
 * Used by fetchIntercept (periodic refresh) and SessionTimeoutModal (user-initiated).
 */
export async function extendSession() {
  const response = await callSessionExtendApi();

  if (response.result === ExtendResult.SUCCESS && response.data && window.store) {
    window.store.dispatch(sessionTimingUpdated(response.data));
  }

  return response;
}

/**
 * Fetches the session timeout configuration from the server and updates Redux.
 * Used at app init (LoginSagas) to learn timeoutMins/promptMins.
 * Shares the same endpoint as extendSession — the server returns config on every call.
 */
export async function fetchSessionTimeoutConfig() {
  return extendSession();
}
